<script>
import Vue from 'vue';
import ExperienceDomain from '~/models/ExperienceDomain';
import ResourceSelect from '~/components/ResourceSelect/ResourceSelect.vue';

export default Vue.extend({
  extends: ResourceSelect,

  props: {
    multiple: {
      type: Boolean,
      required: false,
      default: true,
    },

    getOptionLabel: {
      type: Function,
      required: false,
      default: (resource) => resource.localized_label,
    },

    query: {
      type: Object,
      required: false,
      default: () => new ExperienceDomain(),
    },
  },

  methods: {
    async fetch() {
      return await this.query.$all();
    },
  },
});
</script>
